import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBxBuildings = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M19 2H9c-1.103 0-2 .897-2 2v6H5c-1.103 0-2 .897-2 2v9a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4c0-1.103-.897-2-2-2ZM5 12h6v8H5v-8Zm14 8h-6v-8c0-1.103-.897-2-2-2H9V4h10v16Z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M11 6h2v2h-2V6Zm4 0h2v2h-2V6Zm0 4.031h2V12h-2v-1.969ZM15 14h2v2h-2v-2Zm-8 .001h2v2H7v-2Z"
	})]
});
export default SvgBxBuildings;
